"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _Link = _interopRequireDefault(require("react-router/es/Link"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashSections = function DashSections(props) {
  var currentDashTab = props.currentDashTab,
      setMobileMenu = props.setMobileMenu,
      dashLinks = props.dashLinks;

  var isActive = function isActive(tab) {
    return (0, _classnames.default)({
      active: tab === currentDashTab
    });
  };

  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "mobile-dash-links"
  }, dashLinks.map(function (_ref, idx) {
    var title = _ref.title,
        href = _ref.href;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "dash-link-".concat(idx)
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      to: href
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: isActive(title.toLowerCase()),
      onClick: function onClick() {
        return setMobileMenu(false)();
      }
    }, title)));
  }));
};

var _default = DashSections;
exports.default = _default;